<template>
  <div v-if="type === 'simple' && show" class="text-center crm-disclaimer">
    <el-link class="simple-title cursor-pointer" @click="openDialog = true">{{ $t('login.disclaimer') }}</el-link>
    <DialogComponent
      :visible.sync="openDialog"
      :title="$t('login.disclaimer')"
      :show-footer="false"
      width="552px"
      class="disclaimer-dialog"
    >
      <DisclaimerContent :content="datas.content" :stylized="'1'" />
    </DialogComponent>
  </div>
  <div v-else-if="show" class="crm-disclaimer">
    <div class="normal-title">
      {{ $t('login.disclaimer') }}
    </div>
    <DisclaimerContent :content="datas.content" :stylized="'0'" />
  </div>
</template>

<script>
import DisclaimerContent from './disclaimer.vue'
import DialogComponent from '@/components/dialog/dialog-component.vue'
export default {
  name: 'Disclaimer',
  components: {
    DialogComponent,
    DisclaimerContent
  },
  props: {
    stylized: {
      type: [String, Number],
      required: true,
      default: '1'
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      datas: {},
      showList: ['showLogin', 'showRegister', 'showBottom'],
      show: false,
      openDialog: false
    }
  },
  // watch: {
  //   '$i18n.locale'() {
  //     this.getDisclaimer()
  //   }
  // },
  mounted() {
    this.getDisclaimer()
  },
  methods: {
    getDisclaimer() {
      this.$ajax({
        url: '/system/disclaimersSetting/list',
        method: 'get'
      }).then(({ code, data }) => {
        if (code === 0) {
          this.datas = data || {}
          this.show = this.datas[this.showList[this.stylized]]
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.crm-disclaimer {
  padding: 12px;
  // margin-bottom: 12px;
}

.disclaimer-dialog {
  /* stylelint-disable-next-line selector-class-pattern */
  ::v-deep .el-dialog__body {
    padding: 24px;
  }
}

.normal-title {
  width: 100%;
  margin: 0 auto;
  font-family: theme('fontFamily.pingFang');
  color: theme('colors.text.secondary');
}

.simple-title {
  font-family: theme('fontFamily.pingFang');
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: theme('colors.text.third');
}
</style>
